import type { InputNumberChangeEvent } from 'primereact/inputnumber'
import { InputNumber as PrimeReactInputNumber } from 'primereact/inputnumber'
import { useId } from 'react'
import './inputNumber.scss'

export interface InputNumberProps {
  value: number | null
  onChange: (value: number | null) => void
  min: number
  max: number
  label: string
  error?: boolean
  required?: boolean
}

function InputNumber({ value, onChange, min, max, label, error = false, required = false }: InputNumberProps) {
  const id = useId()
  const currentValue = value ?? null

  const onInputNumberChange = (event: InputNumberChangeEvent) => {
    onChange(event.value)
  }

  const inputNumberClass = error ? 'p-invalid' : ''

  return (
    <div className='input-number'>
      <label htmlFor={id} className='input-number__label'>
        {label}
        {required && <span className='required'>*</span>}
      </label>
      <PrimeReactInputNumber
        value={currentValue}
        onChange={onInputNumberChange}
        min={min}
        max={max}
        inputId={id}
        className={inputNumberClass}
        showButtons
      />
    </div>
  )
}

export default InputNumber
